// GENERATED — DO NOT HAND-EDIT.
//
// Source of truth: specs/tier-05-experience/import-batch.entity-hint.yaml
// Generator: tools/v2-gen/v2gen.py
// Regenerate via: make v2-generate-screens
//
// Hand-edits to non-override-block content WILL be lost on next
// regeneration. See specs/_product/dashboard-v2-page-generator.md §5
// for override blocks (imports / helpers / header-actions).

import type { ListPageConfig } from "../../components/composition/ListPage";
import { importBatchesApi } from "../../api/import-batches";
import type { ImportBatch } from "../../api/types";
// override-block:imports BEGIN
import type { ImportBatchStatus, ImportEntityType } from "../../api/types";
// override-block:imports END

// override-block:helpers BEGIN
const STATUS_LABEL: Record<ImportBatchStatus, string> = {
  pending: "Pending",
  mapping: "Mapping",
  validated: "Validated",
  executing: "Executing",
  completed: "Completed",
  failed: "Failed",
  canceled: "Canceled",
};

const ENTITY_TYPE_LABEL: Record<ImportEntityType, string> = {
  donor: "Donors",
  donation: "Donations",
  pledge: "Pledges",
  recurring_donation: "Recurring donations",
  prospect: "Prospects",
};
// override-block:helpers END

export const importBatchListConfig: ListPageConfig<ImportBatch> = {
  title: "Imports",
  subtitle: "Bulk-data-import jobs — CSV uploads progressing through pending → mapping → validated → executing → completed/failed.",
  queryKey: ["import-batches", "list"] as const,
  queryFn: ({ page, pageSize, sortField, sortDirection, search }) =>
    importBatchesApi.listImportBatches({ page, pageSize, sortField, sortDirection, search }),
  defaultSort: { field: "created_at", direction: "desc" },
  pageSize: 50,
  rowHref: "/imports/{id}",
  search: { enabled: true, placeholder: "Search by entity type or status…" },
  emptyState: {
    title: "No imports yet",
    subtitle: "Upload a CSV to migrate donors, donations, pledges, or recurring giving from another system.",
  },
  headerActions: [
    // override-block:header-actions BEGIN
    // override-block:header-actions END
  ],
  columns: [
    // override-block:column-entity-type BEGIN
    { field: "entity_type", label: "Entity", type: "custom", sortable: true, render: (row) => ENTITY_TYPE_LABEL[row.entity_type] ?? row.entity_type },
    // override-block:column-entity-type END
    // override-block:column-status BEGIN
    { field: "status", label: "Status", type: "custom", sortable: true, render: (row) => STATUS_LABEL[row.status] ?? row.status },
    // override-block:column-status END
    { field: "total_rows", label: "Total", type: "number", sortable: true },
    { field: "valid_rows", label: "Valid", type: "number" },
    { field: "invalid_rows", label: "Invalid", type: "number" },
    { field: "executed_rows", label: "Executed", type: "number" },
    { field: "created_at", label: "Created", type: "relative-date", sortable: true },
  ],
};
